<template>
  <div class="thelink">
    <div v-if="isHidden" class="pb-2 flex flex-col">
          <div class="pattern-colors flex flex-row -mx-3 -mt-1 mb-1">
              <div class="w-2/3" :style="firstcolor"></div>
              <div class="w-1/3" :style="secondcolor"></div>
          </div>
          <span class="pattern-title">{{ ordinal }}</span>
          <a @click="isHidden = !isHidden" class="text-xs py-1 px-3 rounded text-white no-underline bg-green-500 whitespace-no-wrap hover:bg-indigo-500 cursor-pointer">Confirm <strong class="font-mono">{{ ordinal }}</strong></a>
    </div>
    <div v-if="!isHidden">
        <div class="flex flex-row -mx-3 -mt-1 mb-1">
          <div class="w-2/3" :style="firstcolor"></div>
          <div class="w-1/3" :style="secondcolor"></div>
        </div>
        <span class="pattern-title font-bold font-mono">{{ ordinal }}</span>
         <div class="text-xs leading-snug bg-teal-700 text-white px-3 py-1 -mr-3">Confirming <strong class="font-mono">{{ ordinal }}</strong></div>
        <div class="verification-confirm-btn text-center" v-show="isSure">
          <span class="text-xxs mb-1 leading-tight">Save Best-Fit and Accuracy</span>

          <vue-slider
            v-model="value"
            :min="60"
            :max="99"
            :tooltip-formatter="formatter"
            @change="sliderChanged"
          />

          <button @click="confirm"
            type="button"
            class="commitbutton p-0 py-1 inline-block btn text-xs w-full shadow-lg mt-1"
            :class="canSave ? 'cursor-pointer' : 'hover:bg-indigo-500 hover:border-indigo-500 hover:text-white opacity-50'"
          >
            Save <strong class="font-mono">{{ ordinal }}</strong>
            <i aria-hidden="true" class="material-icons align-middle text-sm">save</i>
          </button>
          <a @click="onClickOutside"
            class="text-red-600 no-underline text-xxs cursor-pointer hover:text-red-900"
          >Cancel</a>
        </div>
    </div>

    <div v-if="!isSure" class="bg-red-600 text-white text-center border-2 border-white w-full p-2 absolute top-0 left-0 text-xs z-50 shadow-md rounded" v-click-outside="onClickOutsideConfirmation">
      <template v-if="demo == 1">
        <i aria-hidden="true" class="material-icons align-middle text-yellow-400">report_problem</i><br>
        <strong>Note:</strong> Only an authorized person may confirm this as their best-fit pattern.
      </template>
      <template v-else>
        I confirm <strong class="text-black font-mono">{{ ordinal }}</strong> fits me best, with an accuracy of <strong class="text-black font-mono">{{ value }}%</strong> <br>
        <a @click="putItem" type="button" class="btn text-sm bg-white text-red-900 commitbutton mt-2 inline-block rounded px-3 py-1 align-middle">Yes, Save.</a> <br>
        <a @click="onClickOutsideConfirmation" type="button" class="btn text-xs bg-red-800 text-red-100 commitbutton mt-2 inline-block rounded px-1 py-0 align-middle">Cancel</a>
      </template>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import VueSlider from 'vue-slider-component'
import axios from 'axios'

export default {
    components: {
      VueSlider
    },
    props: {
        route:'',
        type: '',
        name: '',
        ordinal: '',
        userid: '',
        initialaccuracy: '',
        primarycolor:'',
        secondarycolor:'',
        demo:'',
        redirectlink: '',
    },

    data() {
      return {
        canSave: false,
        isHidden: true,
        isSure: true,
        success: false,
        loaded: true,
        user_id: this.userid,
        confirmed_type: this.type,
        value: this.initialaccuracy,
        formatter: '{value}%',
        redirect: this.redirectlink,
        firstcolor: {
          backgroundColor: this.primarycolor
        },
        secondcolor: {
          backgroundColor: this.secondarycolor
        },
      }
    },

    directives: {
      clickOutside: vClickOutside.directive
    },

    methods: {
      confirm () {
        if (this.canSave) {
          this.isSure = ! this.isSure;
        }
      },
      onClickOutside (event) {
          this.isHidden = !this.isHidden
      },
      onClickOutsideConfirmation (event) {
          this.isSure = !this.isSure
      },
      putItem: function (event) {
        let url = this.redirectlink;
        if (this.loaded) {
          this.loaded = false;
          this.success = false;
          $( ".commitbutton").addClass( "loading" );
          axios.post(this.route,
            { accuracy: this.value, user_id: this.user_id, type: this.confirmed_type }
          )
          .then(function (response) {
              console.log(response);
            }).then(function (event) {
              window.location.href = url;
            })
        };
      },
      sliderChanged () {
        this.canSave = true;
      },
    },
  }
</script>
